export * from './create-tp-jobseeker-profile-education-record.mutation.generated'
export * from './delete-tp-jobseeker-profile-education-record.mutation.generated'
export * from './patch-tp-jobseeker-profile-education-record.mutation.generated'
